module.exports = __webpack_public_path__ + "static/whoops-screenshot-93f7f71280bdc9a26c3133cac37a21c4.png";